import { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid-enterprise';
import { ExtendedFund } from '~/components/ui/tables/ag/documentsGroupTable/types';

export const getDocumentsGroupContextMenu = (
  params: GetContextMenuItemsParams<ExtendedFund>,
  callbacks: {
    showEditFundPopup: (fundId: string) => void;
    goToFundPage: (fundId: string) => void;
  },
): (string | MenuItemDef)[] => {
  const result: (string | MenuItemDef)[] = [
    {
      name: 'Edit Fund',
      // action: async () => {
      action: () => {
        if (params?.node?.data?.fundId)
          callbacks.showEditFundPopup(params.node.data.fundId);
      },
      disabled: !params?.node?.data?.fundId,
      cssClasses: ['red', 'bold'],
    },
    {
      name: 'Show Documents',
      action: async () => {
        if (params?.node?.data?.fundId)
          await callbacks.goToFundPage(params.node.data.fundId);
      },
      disabled: !params?.node?.data?.fundId,
      cssClasses: ['red', 'bold'],
    },
    'separator',
    'paste',
    'copy',
    'separator',
  ];
  return result;
};
